import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import { MapContainer, TileLayer, Polygon, useMapEvents, Marker } from 'react-leaflet';
import L from 'leaflet';
import currIcon from '../assets/location.png';
import { createParking, createTrashMap, getTrashMap } from '../helper/backend_helper';
import InfoTooltip from '../components/InfoTooltip';
import 'leaflet/dist/leaflet.css';

const icon = L.divIcon({
  html: `
        <div style="
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%; /* Fully rounded */
          width: 40px; /* Width of the marker */
          height: 40px; /* Height of the marker */
          padding:0
        ">
          <img 
            src="${currIcon}" 
            alt="bag-icon" 
            style="width: 60%; height: 60%;" 
          />
        </div>
      `,
  iconSize: [40, 40], // Matches the size of the outer div
  iconAnchor: [20, 40], // Anchor at the bottom center
  popupAnchor: [0, -40], // Popup above the marker
  className: '',
});
const TrashMapPage = () => {
  const [coordinates, setCoordinates] = useState([]);

  async function fetchData() {
    try {
      const res = await getTrashMap();
      console.log(res);
      setCoordinates(res?.data?.data?.coordinates);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  console.log(coordinates);
  // Add coordinate on map click
  const MapClickHandler = () => {
    useMapEvents({
      click: (e) => {
        const { lat, lng } = e.latlng;
        setCoordinates((prev) => [...prev, { latitude: lat, longitude: lng }]);
      },
    });
    return null;
  };

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (coordinates.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Trash is required',
        });
        return;
      }

      const Categorydata = {
        coordinates,
      };
      console.log(Categorydata);
      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createTrashMap(Categorydata, Categoryheaders);

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Trash Map created successfully',
      });
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Trash is Required`,
      });
    }
  };
  const handleMarkerClick = (clickedLat, clickedLng) => {
    setCoordinates((prev) =>
      prev.filter((coord) => !(coord.latitude === clickedLat && coord.longitude === clickedLng))
    );
  };
  return (
    <>
      <Helmet>
        <title> Trash Map </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Typography variant="h4">Trash Map{' '}<InfoTooltip width={20} title="An interactive map that pinpoints where guests should drop off their waste. Each marker is a set of latitude and longitude coordinates saved as a single trash-map record. Click empty spots on the map to add drop-off points, click an existing marker to remove it, then press Save to store the updated locations for the guest app." /></Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '50ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <div style={{ height: '60vh', width: '100%', marginTop: 20 }}>
            <MapContainer
              center={[40.91551033210304, 16.759643554687504]}
              zoom={9}
              style={{ height: '100%', width: '100%' }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"
              />
              <MapClickHandler />
              {coordinates?.map((coord, index) => (
                <Marker
                  eventHandlers={{
                    click: () => handleMarkerClick(coord.latitude, coord.longitude),
                  }}
                  icon={icon}
                  key={index}
                  position={[coord.latitude, coord.longitude]}
                />
              ))}
            </MapContainer>
          </div>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default TrashMapPage;
